import FadeInSection from "./FadeInSection";
import aboutTeam from "@/assets/about-team.webp";

const AboutSection = () => {
  return (
    <section className="section-padding">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
        <FadeInSection>
          <p className="text-sm font-body font-light tracking-[0.3em] uppercase text-accent mb-6">
            The Studio
          </p>
          <h2 className="heading-lg text-foreground mb-8">
            A Legacy of<br />Bespoke Design
          </h2>
          <div className="divider-line mb-8" />
          <p className="body-lg mb-6">
            AV Design International is a premier architectural and interior design firm 
            with a dual presence in Dubai, UAE and Krakow, Poland. For over a decade, 
            we have bridged the gap between visionary architecture and functional comfort.
          </p>
          <p className="body-lg">
            Our approach is rooted in bespoke solutions — from luxurious hospitality 
            interiors to innovative urban planning. Every project is a convergence of 
            vibrant details that collide to create a dynamic, immersive experience.
          </p>
        </FadeInSection>

        <FadeInSection delay={0.2}>
          <div className="relative">
            <img
              src={aboutTeam}
              alt="AV Design team collaborating on architectural plans"
              className="w-full h-[500px] object-cover"
              loading="lazy"
              width={1200}
              height={800}
            />
            <div className="absolute -bottom-6 -left-6 bg-foreground text-primary-foreground p-8">
              <p className="font-heading text-5xl">25+</p>
              <p className="text-sm font-body font-light tracking-widest uppercase mt-1">
                Years Legacy
              </p>
            </div>
          </div>
        </FadeInSection>
      </div>
    </section>
  );
};

export default AboutSection;
